module.exports = __webpack_public_path__ + "static/images/xinxiliu_62bfaa48.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/posbannerblack/xinxiliu.png
// module id = 241
// module chunks = 1